// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout_layout__AdhQA","maximized":"Layout_maximized__EPSyY"};